import { indexData } from '@/mocks/chiguaHomeData';

export default function IndexSection() {
  const colorIconMap: Record<string, string> = {
    primary: 'bg-primary-100 text-primary-600',
    accent: 'bg-accent-100 text-accent-600',
    secondary: 'bg-secondary-100 text-secondary-600',
  };

  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            专题索引
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            按分类快速浏览今日吃瓜在线观看内容，找到你感兴趣的八卦话题
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4 max-w-5xl mx-auto">
          {indexData.slice(0, 5).map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-background-50 rounded-xl p-4 md:p-5 text-center cursor-pointer hover:-translate-y-1 transition-all duration-300 block no-underline"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl mx-auto mb-3 ${colorIconMap[item.color]}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1 whitespace-nowrap">
                {item.title}
              </h3>
              <span className="text-xs text-foreground-500">{item.count} 篇</span>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4 max-w-4xl mx-auto mt-4">
          {indexData.slice(5).map((item, i) => (
            <a
              key={i + 5}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-background-50 rounded-xl p-4 md:p-5 text-center cursor-pointer hover:-translate-y-1 transition-all duration-300 block no-underline"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl mx-auto mb-3 ${colorIconMap[item.color]}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1 whitespace-nowrap">
                {item.title}
              </h3>
              <span className="text-xs text-foreground-500">{item.count} 篇</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}